import React from 'react';
import KickImage from 'Reuseables/KickImage';

//Components - Reuseables
import Link from "Reuseables/Link"

import { IArticleTagsProps } from './ArticleTags.definitions';

/** CSS import */
import Styles from './ArticleTags.module.scss';

const ArticleTags: React.FC<IArticleTagsProps> = ({
  text,
  slug
}: IArticleTagsProps) => {
  return (
    <Link to={`/kickavenews/tag/${slug}`}>
      <div className={Styles['wrapper']}>
        <p>#{text}</p>
      </div>
    </Link>
  );
};

export default ArticleTags;
